import React from 'react';
import { SecureShieldIcon } from '../Icons';
import { MuiBox, MuiCircularProgress } from '../material-ui';

const Authenticating = () => (
  <MuiBox display="flex" justifyContent="center" position="relative" alignItems="center">
    <MuiBox width={0} display="flex" justifyContent="center">
      <MuiBox>
        <MuiCircularProgress size={100} thickness={1.5} color="secondary" />
      </MuiBox>
    </MuiBox>
    <MuiBox
      width={0}
      display="flex"
      justifyContent="center"
      flexWrap="nowrap"
      fontSize={48}
      marginBottom="5px"
      color="secondary.main"
    >
      <SecureShieldIcon color="inherit" fontSize="inherit" />
    </MuiBox>
  </MuiBox>
);

export default Authenticating;
